import { combineReducers } from '@reduxjs/toolkit';
import partner from "./partnerSlice";
import partnerDuration from './partnerDurationSlice'
import partnerShippingPayers from './shippingPayerSlice'
import partnerShippingRules from './shippingRulesSlice'
import partnerReturnCostPayers from './partnerReturnCostPayersSlice'
import partnerOrderConditions from './partnerOrderConditionsSlice'
import partnerOrderReceivedMethods from './partnerOrderReceivedMethodsSlice'
import partnerManuals from './partnerManualsSlice'
import partnerShopifySalesChannels from './partnerShopifySalesChannelsSlice'
import partnerAutomaticApps from './partnerAutomaticAppsSlice'
import partnerStockUpdateIntervals from './partnerStockUpdateIntervalsSlice'

const partnerReducer = combineReducers({
    partner,
    partnerDuration,
    partnerShippingPayers,
    partnerShippingRules,
    partnerReturnCostPayers,
    partnerOrderConditions,
    partnerOrderReceivedMethods,
    partnerManuals,
    partnerShopifySalesChannels,
    partnerAutomaticApps,
    partnerStockUpdateIntervals
});

export default partnerReducer;